// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_gz-0";